<div class="p-4 md:p-6 max-w-7xl mx-auto">
  <!-- Header -->
  <h1 class="text-2xl font-bold text-gray-800 flex items-center mb-6">
    <mat-icon style="color: #1C593D; margin-right: 8px;">account_balance_wallet</mat-icon>
    Balance Cajero
    <span *ngIf="dataSource" class="hidden md:inline text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full ml-2">
      {{ dataSource.data.length }} registros
    </span>
  </h1>

  <!-- Card Filtros -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-6">
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;">
      <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">filter_list</mat-icon>
        Filtros de Búsqueda
      </h2>
    </div>
    <div class="p-5">
      <div class="flex flex-col lg:flex-row items-end gap-4">
        <!-- Select cuenta -->
        <mat-form-field appearance="outline" class="modern-field w-full lg:w-96">
          <mat-label>Cuenta</mat-label>
          <mat-select required [(ngModel)]="cuentaSeleccionada">
            <mat-option>Seleccione cuenta</mat-option>
            <mat-option *ngFor="let cuenta of cuentasTrabajo" [value]="cuenta.cuenta_trabajo_id">
              {{ cuenta.nombre | titlecase }} {{ cuenta.apellidos | titlecase }} {{ cuenta.banco?.nombre }} {{ cuenta.numeroCuenta }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Date range -->
        <mat-form-field appearance="outline" class="modern-field w-full lg:w-auto">
          <mat-label>Rango de fechas</mat-label>
          <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
            <input matStartDate formControlName="start" placeholder="Fecha inicio">
            <input matEndDate formControlName="end" placeholder="Fecha fin">
          </mat-date-range-input>
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
          <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">Fecha inicio inválida</mat-error>
          <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">Fecha fin inválida</mat-error>
        </mat-form-field>

        <!-- Botones -->
        <div class="flex w-full sm:w-auto gap-2 mb-1">
          <button type="button" (click)="loadData()"
            class="flex-1 sm:flex-none"
            style="display: inline-flex; align-items: center; justify-content: center; gap: 8px; padding: 10px 36px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
            onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">search</mat-icon>
            Buscar
          </button>
          <button *ngIf="dataSource" type="button" (click)="exportData()"
            class="flex-1 sm:flex-none"
            style="display: inline-flex; align-items: center; justify-content: center; gap: 8px; padding: 10px 24px; background: white; color: #1C593D; border: 2px solid #1C593D; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: all 0.2s ease;"
            onmouseover="this.style.background='#1C593D';this.style.color='white'" onmouseout="this.style.background='white';this.style.color='#1C593D'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px;">download</mat-icon>
            Exportar
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Contador mobile -->
  <span *ngIf="dataSource" class="md:hidden inline-block text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full mb-4">
    {{ dataSource.data.length }} registros
  </span>

  <!-- Tabla Desktop -->
  <div class="hidden lg:block bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden" *ngIf="dataSource">
    <div class="overflow-x-auto">
      <table mat-table [dataSource]="dataSource">

        <!-- Saldo -->
        <ng-container matColumnDef="saldo">
          <th mat-header-cell *matHeaderCellDef>Saldo</th>
          <td mat-cell *matCellDef="let row">
            <span class="font-bold" style="color: #1e5a3f;">{{ row.saldo_actual | currency:'USD':'symbol-narrow':'1.2-2' }}</span>
          </td>
        </ng-container>

        <!-- Tipo Transacción -->
        <ng-container matColumnDef="tipoTransaccion">
          <th mat-header-cell *matHeaderCellDef>Tipo</th>
          <td mat-cell *matCellDef="let row">
            {{ row.tipo_transaccion }} {{ getTipoTransaccion(row.banco, row.tipo_transaccion) }}
          </td>
        </ng-container>

        <!-- Id Transacción -->
        <ng-container matColumnDef="idTransaccion">
          <th mat-header-cell *matHeaderCellDef>Id Trx</th>
          <td mat-cell *matCellDef="let row">
            {{ row.transaction_id || '' }}
          </td>
        </ng-container>

        <!-- Monto CLP -->
        <ng-container matColumnDef="montoclp">
          <th mat-header-cell *matHeaderCellDef>CLP</th>
          <td mat-cell *matCellDef="let row">
            <span *ngIf="row.monto_origen">{{ row.monto_origen | currency:'USD':'symbol-narrow':'1.2-2' }}</span>
          </td>
        </ng-container>

        <!-- Monto Destino -->
        <ng-container matColumnDef="montobs">
          <th mat-header-cell *matHeaderCellDef>Destino</th>
          <td mat-cell *matCellDef="let row">
            <span class="font-bold" style="color: #1e5a3f;">{{ row.monto_general | currency:'USD':'symbol-narrow':'1.2-2' }}</span>
          </td>
        </ng-container>

        <!-- Precio Compra -->
        <ng-container matColumnDef="precioCompra">
          <th mat-header-cell *matHeaderCellDef>P. Compra</th>
          <td mat-cell *matCellDef="let row">
            {{ row.precio_compra_usdt }}
          </td>
        </ng-container>

        <!-- Beneficiario -->
        <ng-container matColumnDef="beneficiario">
          <th mat-header-cell *matHeaderCellDef>Beneficiario</th>
          <td mat-cell *matCellDef="let row">
            {{ row.nombre || '' }} {{ row.apellidos || '' }}
            <br *ngIf="getIdentificador(row)">
            <span *ngIf="getIdentificador(row)" class="text-xs text-gray-500">{{ getIdentificador(row) }}</span>
          </td>
        </ng-container>

        <!-- Banco -->
        <ng-container matColumnDef="banco">
          <th mat-header-cell *matHeaderCellDef>Banco</th>
          <td mat-cell *matCellDef="let row">
            {{ row.banco || '' }}
          </td>
        </ng-container>

        <!-- Cuenta -->
        <ng-container matColumnDef="cuenta">
          <th mat-header-cell *matHeaderCellDef>Cuenta</th>
          <td mat-cell *matCellDef="let row">
            {{ row.numero_cuenta || '' }}
          </td>
        </ng-container>

        <!-- Referencia -->
        <ng-container matColumnDef="referencia">
          <th mat-header-cell *matHeaderCellDef>Ref.</th>
          <td mat-cell *matCellDef="let row">
            {{ row.referencia || '' }}
          </td>
        </ng-container>

        <!-- Fecha -->
        <ng-container matColumnDef="fecha">
          <th mat-header-cell *matHeaderCellDef>Fecha</th>
          <td mat-cell *matCellDef="let row">
            {{ getFormattedDate(row.created_at) }}
          </td>
        </ng-container>

        <!-- Operador -->
        <ng-container matColumnDef="operador">
          <th mat-header-cell *matHeaderCellDef>Operador</th>
          <td mat-cell *matCellDef="let row">
            {{ row.email_operador || 'N/A' }}
          </td>
        </ng-container>

        <!-- Saldo Deudor -->
        <ng-container matColumnDef="saldo_deudor">
          <th mat-header-cell *matHeaderCellDef>S. Deudor</th>
          <td mat-cell *matCellDef="let row">
            {{ row.precio_compra || 0 }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </div>

  <!-- Cards Mobile -->
  <div class="lg:hidden space-y-3" *ngIf="dataSource">
    <div *ngFor="let row of dataSource.data; let i = index"
      class="bg-white rounded-xl shadow-sm border overflow-hidden transition-all duration-200"
      [style.borderColor]="expandedCardId === i ? '#1C593D' : '#e5e7eb'">

      <!-- Card header -->
      <div class="flex items-center justify-between p-3 cursor-pointer"
        (click)="toggleCard(i)"
        [style.background]="expandedCardId === i ? '#f0fdf4' : 'white'">
        <div class="flex items-center gap-2 flex-1 min-w-0">
          <span *ngIf="row.transaction_id" class="font-mono font-bold text-xs bg-green-100 text-green-800 px-2 py-0.5 rounded-full shrink-0">#{{ row.transaction_id }}</span>
          <span class="px-2 py-0.5 text-xs font-semibold rounded-full bg-blue-100 text-blue-700 shrink-0">
            {{ row.tipo_transaccion }}
          </span>
          <span class="text-sm font-bold truncate" style="color: #1e5a3f;">{{ row.saldo_actual | currency:'USD':'symbol-narrow':'1.2-2' }}</span>
        </div>
        <mat-icon class="text-gray-400 shrink-0 transition-transform duration-200"
          [style.transform]="expandedCardId === i ? 'rotate(180deg)' : 'rotate(0)'">
          expand_more
        </mat-icon>
      </div>

      <!-- Card body -->
      <div *ngIf="expandedCardId === i" class="px-3 pb-3 border-t border-gray-100">
        <div class="grid grid-cols-2 gap-2 mt-3 text-xs">
          <div>
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Monto CLP</span>
            <p class="text-gray-700 font-medium mt-0.5">{{ row.monto_origen ? (row.monto_origen | currency:'USD':'symbol-narrow':'1.2-2') : '-' }}</p>
          </div>
          <div>
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Monto Destino</span>
            <p class="font-bold mt-0.5" style="color: #1e5a3f;">{{ row.monto_general | currency:'USD':'symbol-narrow':'1.2-2' }}</p>
          </div>
          <div>
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Precio Compra</span>
            <p class="text-gray-700 font-medium mt-0.5">{{ row.precio_compra_usdt }}</p>
          </div>
          <div>
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Beneficiario</span>
            <p class="text-gray-700 font-medium mt-0.5">{{ row.nombre || '' }} {{ row.apellidos || '' }}</p>
            <p *ngIf="getIdentificador(row)" class="text-gray-500 font-medium mt-0.5">{{ getIdentificador(row) }}</p>
          </div>
          <div>
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Banco</span>
            <p class="text-gray-700 font-medium mt-0.5">{{ row.banco || '-' }}</p>
          </div>
          <div>
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Cuenta</span>
            <p class="text-gray-700 font-mono font-medium mt-0.5">{{ row.numero_cuenta || '-' }}</p>
          </div>
          <div>
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Referencia</span>
            <p class="text-gray-700 font-mono font-medium mt-0.5">{{ row.referencia || '-' }}</p>
          </div>
          <div>
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Fecha</span>
            <p class="text-gray-700 font-medium mt-0.5">{{ getFormattedDate(row.created_at) }}</p>
          </div>
          <div>
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Operador</span>
            <p class="text-gray-700 font-medium mt-0.5">{{ row.email_operador || 'N/A' }}</p>
          </div>
          <div>
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Saldo Deudor</span>
            <p class="text-gray-700 font-medium mt-0.5">{{ row.precio_compra || 0 }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
